import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const CIE_10 = {
  id: 'report.cie',
  title: 'Certificado Médico - CIE 10',
  labels: {
    ...COMMONS,
    patientInformation: 'Información del paciente',
    medicalInformation: 'Atención médica',
    cie: 'CIE 10',
    ciePlaceholder: 'Ingresa el diagnóstico',
    documentPlaceholder: 'Número de cédula / Pasaporte',
    dateAttendance: COMMONS.date,
    datePlaceholder: 'dd-mm-yyyy',
    doctor: 'Médico/a tratante',
    doctorPrefixPlaceholder: 'Dr./Dra.',
    doctorSpecialty: 'Especialidad',
    doctorSpecialtyPlaceholder: 'Ingrese la especialidad',
    medicalRestDateRange: 'Reposo médico',
    medicalRestDateRangePlaceholder: 'dd-mm-yyyy  al  dd-mm-yyyy',
    rangeDateSeparator: '  al  '
  },

  actions: {
    ...ACTIONS,
    generate: 'Generar Certificado'
  }
};
